import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.meta.savedPosition) {
      return to.meta.savedPosition
    } else {
      return { left: 0, top: 0 }
    }
  }
}
